import React from "react";
import Modal from "../modal/modal";

import { PrimaryButton } from "../simple-buttons/simple-buttons";
import { PageActionsContainer } from "../theme/containers";
import BoiReactMarkdown from "./../boi-markdown/boi-markdown";
import { replaceMergeTagsInString } from "./../forms/helper";
import { FormContext, iControlProps } from "./../forms/types";

const isIE = () => /Trident.*rv[ :]*11\./.test(navigator.userAgent);
const isFF = () => /Firefox\/*/.test(navigator.userAgent);
const isiOS = () =>
    /iPhone|iPad|iPod/.test(navigator.platform) ||
    (/Mac/.test(navigator.userAgent) && "ontouchend" in document);
const isAndroid = () => /Android/i.test(navigator.userAgent);
const isFFonIOS = () => /FxiOS/i.test(navigator.userAgent);

type UnsupportedBrowserProps = iControlProps & {
    context?: FormContext;
    browserList?: { [key: string]: boolean };
    modalContent?: string;
    modalButtonLabel?: string;
    modalButtonUrl?: string;
};

const UnsupportedBrowserScreen = (props: UnsupportedBrowserProps) => {
    const {
        context,
        cssClass,
        browserList,
        modalContent,
        modalButtonUrl,
        modalButtonLabel
    } = props;
    let isOpen = false;

    for (const key in browserList) {
        /* istanbul ignore else */
        if (
            Object.prototype.hasOwnProperty.call(browserList, key) &&
            browserList[key] === true &&
            !isOpen
        ) {
            switch (key) {
                // For FireFox on every device
                case "firefox":
                    isOpen = isFF() || isFFonIOS();
                    break;
                // For FireFox on every Android devices
                case "firefoxAndroid":
                    isOpen = isFF() && isAndroid();
                    break;
                // For FireFox on iOS devices
                case "firefoxIOS":
                    isOpen = isFFonIOS();
                    break;
                // For IE on every device
                case "internetExplorer":
                    isOpen = isIE();
                    break;

                default:
                    break;
            }
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            className={`fullPage ${cssClass || ""}`}
            overlayClassName="fullPage"
            modalName="unsupportedBrowser"
        >
            <div className="u-text-centre u-mt-6 u-pt-6">
                <BoiReactMarkdown>
                    {replaceMergeTagsInString(
                        modalContent || "",
                        context ? context.getValues() : {}
                    )}
                </BoiReactMarkdown>
                <PageActionsContainer className="block" id="actions">
                    <PrimaryButton as="a" href={modalButtonUrl} text={modalButtonLabel} />
                </PageActionsContainer>
            </div>
        </Modal>
    );
};

UnsupportedBrowserScreen.defaultProps = {
    modalContent:
        "![Info icon](https:&#47;&#47;digital.bankofireland.com&#47;cdn&#47;img&#47;icon-info.svg)\r\n" +
        "# You're using an unsupported browser.\r\n" +
        "We recommend applying on your smartphone or tablet (it's quickest). If you still want to apply here, you will need to update or use a different browser.",
    modalButtonUrl: "https://www.bankofireland.com",
    modalButtonLabel: "Exit"
};

export { isIE, isFF, isiOS, isAndroid, isFFonIOS };
export default UnsupportedBrowserScreen;
